import { parse as papaParse, ParseResult } from 'papaparse';
import { KostDataImportDatasetInputProcessorProgressEvent } from '@bindoc-projects/kost-data-import-domain-lib';
import {
  KOST_FILE_NAMES,
  KOST_FILES_REQUIRED,
  KostFileNames,
} from './de-kost-file.const';

export class P21FileParser {
  public static parse(
    files: {
      [fileType in KostFileNames]: string;
    },
    progressCallback: (
      event: KostDataImportDatasetInputProcessorProgressEvent,
    ) => void,
  ): {
    result?: { [fileType in KostFileNames]: string[][] };
    errors?: string[];
  } {
    progressCallback({ step: 'FILE_PARSING', current: 0, max: 1 });
    const errors: string[] = [];
    const fileContents = new Map(Object.entries(files));
    const requiredFiles = new Map(Object.entries(KOST_FILES_REQUIRED));
    const result = Object.fromEntries(
      KOST_FILE_NAMES.map((fileType) => {
        const content = fileContents.get(fileType);
        if (!content && requiredFiles.get(fileType)) {
          errors.push(`Keine Daten für ${fileType} gefunden.`);
        }
        const rows = content
          ? (
              papaParse(content, {
                skipEmptyLines: 'greedy',
              }) as unknown as ParseResult<string[]>
            ).data
          : null;
        return [fileType, rows];
      }),
    ) as Record<KostFileNames, string[][]>;
    const data = { result, errors };

    progressCallback({ step: 'FILE_PARSING', current: 1, max: 1 });

    return data;
  }
}
